import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

import { TableLoader } from "../../../Common/ShimmerLoader";
import MUITable from "../../../Common/MUITable";
import isGHMC from "../../../Common/helper/helpar";

import { ExportIEKpiType } from "./ExportIEType";
import AddEditIEKpiTypeForm from "./AddEditIEKpiTypeForm";

import {
  formatDisplayDate,
  useIEKpiTypeStore,
} from "./IEKpiTypeStore/useIEKpiTypeStore";
import { StatusBadge } from "../../Rfid/utils/statusBadge";

const IEKpiTypeRootComponent = () => {
  const isProd = isGHMC();
  const formatDisplayDate = (date) => {
    if (!date) return "";

    return date.replace("T", " ");
  };

  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const {
    filteredIeKpiTypes,
    isLoading,
    filters,
    fetchIeKpiTypes,
    updateFilter,
    applyFilters,
    addIeKpiType,
    updateIeKpiType,
  } = useIEKpiTypeStore();

  useEffect(() => {
    fetchIeKpiTypes();
  }, []);

  const handleSearchChange = (event) => {
    const { name, value } = event.target;

    updateFilter(name, value);

    applyFilters(undefined, {
      ...filters,
      [name]: value,
    });
  };

  const handleAdd = () => {
    setSelectedRow(null);
    setShowModal(true);
  };

  const handleEdit = (row) => {
    setSelectedRow({
      kpiTypeId: row.kpiTypeId,
      kpiCode: row.kpiCode,
      kpiType: row.kpiTypeName,
      isActive: row.isActive,
    });

    setShowModal(true);
  };

  const handleSubmit = async (values) => {
    try {
      let response;

      if (selectedRow) {
        response = await updateIeKpiType({
          ...values,
          kpiTypeId: selectedRow.kpiTypeId,
        });
      } else {
        response = await addIeKpiType(values);
      }

      if (response.success) {
        setShowModal(false);
        setSelectedRow(null);

        await fetchIeKpiTypes();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const ieKpiTypeColumns = [
    {
      label: "KPI Code",
      field: "kpiCode",
    },
    {
      label: "KPI Type",
      field: "kpiTypeName",
    },
    {
      label: "Status",
      render: (row) => <StatusBadge isActive={row.isActive} compact />,
    },
    {
      label: "Last Modified On",
      field: "modifiedDate",
      width: 180,
      render: (row) => formatDisplayDate(row.modifiedDate),
    },
    {
      label: "Actions",
      render: (row) => (
        <button
          type="button"
          className={isProd ? "edit-ghmc" : "edit-swm"}
          onClick={() => handleEdit(row)}
          aria-label={`Edit ${row.kpiTypeName}`}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
  ];

  return (
    <>

      <div className="content text-start">
        <div className="page-content">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mt-3">
            <div>
              <h5 className="mb-1 fw-semibold">
                IE KPI Type Information
              </h5>
              <p className="text-muted mb-0">
                Manage Independent Engineer KPI Types for
                performance monitoring and evaluation.
              </p>
            </div>

            <div className="d-flex align-items-center flex-wrap">
              <button
                type="button"
                className="button-container"
                onClick={handleAdd}
              >
                <FaPlus className="font-size-20 me-1" />
                Add KPI Type
              </button>

              <ExportIEKpiType
                ieKpiTypeData={filteredIeKpiTypes}
              />
            </div>
          </div>

          <div className="card shadow mt-3">
            <div className="card-body">
              <div className="row align-items-end">
                <div className="col-md-4 mb-3">
                  <label className="form-label">
                    Search KPI Type
                  </label>

                  <input
                    type="text"
                    name="searchTerm"
                    value={filters.searchTerm}
                    onChange={handleSearchChange}
                    placeholder="Enter KPI Code / KPI Type"
                    className="form-control bg-white"
                  />
                </div>
              </div>

              <div>
                <div className="top-header text-center">
                  <span>IE KPI Type List</span>
                </div>

                <MUITable loading={isLoading}
                  needSRNumber
                  rows={filteredIeKpiTypes || []}
                  columns={ieKpiTypeColumns}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add/Edit Modal */}
      <AddEditIEKpiTypeForm
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          setSelectedRow(null);
        }}
        onSubmit={handleSubmit}
        isEdit={!!selectedRow}
        initialData={selectedRow}
      />
    </>
  );
};

export default IEKpiTypeRootComponent;